import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ConfigService } from '../../../config/config.service';

export interface Notification {
  id: string;
  message: string;
  start_date: string;
  end_date: string;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  public getNotif(): Observable<Notification> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Notification>(config.apiPoint + config.getNotif);
      })
    );
  }
}
